export const SAVED_LAYOUT_KEY = 'savedStimulusLayoutSelection';

export enum AddQuestionsActionsName {
    FETCH_QUESTION_DETAILS = 'FETCH_QUESTION_DETAILS',
    SET_SELECTED_QUESTION_DETAILS = 'SET_SELECTED_QUESTION_DETAILS',
    CLEAR_QUESTION_DEATILS = 'CLEAR_QUESTION_DEATILS',
    SET_SAVED_LAYOUT = 'SET_SAVED_LAYOUT',
}

export interface FetchSelectedQuestionDetails {
    type: AddQuestionsActionsName.FETCH_QUESTION_DETAILS;
    stimulusContentRevisionId: number;
}
export interface SetSelectedQuestionDetails {
    type: AddQuestionsActionsName.SET_SELECTED_QUESTION_DETAILS;
    textContent: string;
    objectType: string;
    title: string;
    questionContentItemId: number;
    stimulusContentRevisionId: number;
}

export interface ClearSelectedQuestionDetails {
    type: AddQuestionsActionsName.CLEAR_QUESTION_DEATILS;
}

export interface SetSavedLayout {
    type: AddQuestionsActionsName.SET_SAVED_LAYOUT;
    savedLayout: string | null;
}

export interface SelectedQuestionDetailsState {
    textContent: string | null;
    objectType: string | null;
    title: string | null;
    questionContentItemId: number | null;
    stimulusContentRevisionId: number | null;
    savedLayout: string | null;
}
